import { useState } from 'react'
import { Box, Popover } from '@mui/material'
import { SwitchAppButtonProps } from './SwitchAppButton.types'
// import { ReactComponent as AppSwitchIcon } from '../../assets/icons/appswitch.svg'

export const SwitchAppButton = ({
  logoOne,
  logoTwo,
  handleLogoOneClick,
  handleLogoTwoClick,
  anchorV = 'bottom',
  anchorH = 'center',
  transformV = 'top',
  transformH = 'right',
}: SwitchAppButtonProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'appswitch-popover' : undefined

  return (
    <>
      <Box
        sx={{ cursor: 'pointer' }}
        onClick={handleClick}
        role="button"
        aria-label="switch app"
        component="span"
      >
        {/* <AppSwitchIcon height='32px' width='32px' /> */}
      </Box>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: anchorV,
          horizontal: anchorH,
        }}
        transformOrigin={{
          vertical: transformV,
          horizontal: transformH,
        }}
      >
        <Box display="flex" p={1}>
          <Box
            sx={{
              cursor: 'pointer',
              margin: '16px 32px',
            }}
            onClick={handleLogoOneClick}
            role="button"
            aria-label="logo one"
          >
            <img
              src={logoOne}
              alt="Switch application"
              height="48px"
              width="58px"
            />
          </Box>
          <Box
            sx={{
              cursor: 'pointer',
              margin: '16px 32px',
            }}
            onClick={handleLogoTwoClick}
            role="button"
            aria-label="logo two"
          >
            <img
              src={logoTwo}
              alt="Switch application"
              height="48px"
              width="80px"
            />
          </Box>
        </Box>
      </Popover>
    </>
  )
}
